import React from 'react';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataCloudMigration } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import BreadcrumbDevOps from '../BreadcrumbDevOps';
import { Link } from 'react-router-dom';

const CloudMigration = () => {
  return (
    <div className="page-container-cloud-migration">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
          <h1 className='heading drop-in'>Cloud Migration </h1>
          </div>
          <Link to="/cloud-migration" className='no-decoration'><BreadcrumbDevOps text={"Cloud Migration"} /></Link>  
            <div className='red-bg-box'></div>
        </div>
        <CardsServices cardDataServices={cardDataCloudMigration} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default CloudMigration